export const ROUTE_PATH = '/settings';
